<template>
    <div class="goodsList">
        <h2 class="h">已選箱子</h2>
        <div class="tipsborder" v-if="boxList.length==0">
            您還未選箱子
        </div>
        <div class="good" v-for="(item,index) in boxList" :key="item.id" v-if="$store.state.boxType == '01'?item.boxType == '01' : item.boxType != '01'">
            <div class="h">
                <span v-if="item.boxType=='01'">信封</span>
                <span v-else-if="item.boxType == '02'">小郵包</span>
                <span v-else-if="item.boxType == '03'">箱子</span>
                <span v-else>板車</span>
            </div>
            <div class="b">
                <div class="left">
                    <div class="number">
                        {{index+1}}
                    </div>
                    <div class="img">
                        <img src="../img/letter.png" v-if="item.boxType=='01'" alt="寄信封">
                        <img src="../img/pack.png"  v-else-if="item.boxType == '02'" alt="寄邮包">
                        <img src="../img/box.png" v-else-if="item.boxType == '03'" alt="寄箱子">
                        <img src="../img/car.png"  v-else alt="寄板车">
                    </div>
                    <div class="size">
                        <div class="name">
                            長x寬x高
                        </div>
                        <div class="bum">
                            {{item.longBox+'x'+item.widthBox+'x'+item.highBox}}
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div>
                        <div class="sum">
                            <p class="moneyType">數量</p>
                            <p class="money">
                                x {{item.count}}
                            </p>
                        </div>
                        <div class="weight">
                            <p class="">重量 </p>
                            <p class="kg">
                                 {{item.volume}}kg
                            </p>
                        </div>
                    </div>
                    <div class="option">
                        <div class="edit" @click="handlerEditBox(item)">
                            <span class="el-icon-edit-outline"></span>
                        </div>
                        <div class="delete" @click="deleteBox(item.id)">
                            <span class="el-icon-error"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 修改参数对话框 -->
        <el-dialog
            title="修改箱子参数"
            :visible.sync="showEditDiglog"
            width="50%"
            :before-close="handerClose"
            :close-on-click-modal="false"
            >
            <el-form :model="orderBoxes" :rules="orderBoxesFormRule" ref="orderBoxesForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="长" prop="longBox">
                    <el-input v-model="orderBoxes.longBox"></el-input>
                </el-form-item>
                <el-form-item label="宽" prop="widthBox">
                    <el-input v-model="orderBoxes.widthBox"></el-input>
                </el-form-item>
                <el-form-item label="高" prop="highBox">
                    <el-input v-model="orderBoxes.highBox"></el-input>
                </el-form-item>
                <el-form-item label="重量" prop="volume">
                    <el-input v-model="orderBoxes.volume"></el-input>
                </el-form-item>
                <el-form-item label="数量" prop="count">
                    <el-input v-model="orderBoxes.count"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showEditDiglog = false">取 消</el-button>
                <el-button type="primary" @click="editBox">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name:'BoxList',
    data(){
        return {
            // 箱子列表
            boxList:[],
            // 控制编辑对话框是否隐藏
            showEditDiglog:false,
            // 面积表单规则
            orderBoxesFormRule:{
                widthBox:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                highBox:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                longBox:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                count:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
                volume:[
                    {required:true,message:'* 必需填寫。',trigger:'blur'}
                ],
            },
            // 面积表单
            "orderBoxes":{
                "type":'',
                "boxid": 0,
                // 数量
                "count": 0,
                // 高
                "highBox": "",
                // 长
                "longBox": "",
                "orderId": 0,
                // 体积重量
                "volume": "",
                // 宽
                "widthBox": ""
            }, 
        }
    },
    methods: {
        // 从vuex获得箱子列表
        getBoxList(){
            this.boxList = this.$store.state.orderVo.orderBoxes
        },
        // 监听用户点击删除盒子
        deleteBox(id){
            console.log(id)
            this.$store.dispatch("editBox",{
                id:id,
                type:'delete'
            })
            this.getBoxList()
        },
        // 监听用户点击编辑
        handlerEditBox(box){
            this.showEditDiglog = true
            this.orderBoxes = box
        },
        // 提交编辑
        editBox(){
            let box = JSON.parse(JSON.stringify(this.orderBoxes))
            this.$refs.orderBoxesForm.validate(async valid=>{
                console.log(box)
                if(!valid) return
                this.$store.dispatch("editBox",{
                    id:box.id,
                    type:"edit",
                    box
                })
                this.getBoxList()
                this.showEditDiglog = false
                this.$refs.orderBoxesForm.resetFields()
            })
        },
        // 监听对话框关闭
        handerClose(){
            this.showEditDiglog = false
            this.$refs.orderBoxesForm.resetFields()
        }
    },
    created() {
        this.getBoxList()
    },
}
</script>

<style lang="less">
     .goodsList{
         margin: 30px 0;
         .h{
             font-size: 18px;
             font-weight:600;
         }
         .tipsborder{
            display: flex;
            align-items: flex-end;
            height: 111px;
            margin-top: 15px;
         }
            .good{
                margin-top: 15px;
                .h{
                    font-size: 17px;
                }
                .b{
                    display: flex;
                    justify-content:space-between ;
                    padding: 20px 0;
                    border-bottom:2px solid #d4d4d4;
                    .left{
                    width: 20%;
                    display: flex;
                    align-items: center;
                    justify-content:space-between ;
                    .number{
                        width: 40px;
                        height: 40px;
                        color:@colorMain;
                        text-align:center;
                        border:2px solid @colorMain;
                        line-height: 35px;
                        border-radius:50%;
                    }
                    .size{
                        .name{
                            font-weight: 550;
                            font-size:17px;
                            margin-bottom:15px;
                        }
                        .num{
                            font-weight: 550;
                            font-size:17px;
                        }
                    }
                    .img{
                        width: 50px;
                        height: 50px;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .size{
                        text-align: center;
                    }
                    }
                    .right{
                        width: 20%;
                        display: flex;
                        justify-content:space-between;
                        align-items: center;
                        .sum{
                            display: flex;
                            .moneyType{
                                font-weight: 550;
                                margin-right: 10px;
                                font-size: 17px;
                            }
                            .money{
                                font-weight: 550;
                                font-size: 17px;
                            }
                        }
                        .weight{
                            display: flex;
                            margin-top: 15px;
                            .kg{
                                margin-left: 10px;
                            }
                        }
                        .option{
                            display: flex;
                            .delete,.edit{
                                font-size: 30px;
                                color:@colorMain;
                                margin-left:10px;
                                &:hover{
                                    cursor: pointer;
                                    opacity: .8;
                                }
                            }
                            .delete{
                                span{
                                    color: #F7320F;
                                }
                            }
                        }
                    }
                }
            }
            .tipsborder{
                padding-bottom: 10px;
                border-bottom:2px solid #d4d4d4;
            }
        }
</style>